module.exports = __webpack_public_path__ + "7dc622fe010e7ced0b075990426a0143.png";